/**
 * App 下载的两条小规矩（CR-054），单独放一个文件好测 —— `download.ts` 拖着 Capacitor 插件。
 */

const BY_EXTENSION: Record<string, string> = {
  zip: 'application/zip',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  heic: 'image/heic',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
};

const GENERIC = new Set(['', 'application/octet-stream', 'binary/octet-stream']);

/**
 * 存进「下载」和「打开」用的 MIME。响应头给了具体类型就用它，给的是笼统的就按扩展名补 ——
 * 「打开」靠它挑应用，`application/octet-stream` 手机上没有应用认，只会说「没有能打开的应用」。
 */
export function mimeTypeFor(filename: string, blobType?: string): string {
  const type = (blobType ?? '').split(';')[0]!.trim().toLowerCase();
  if (!GENERIC.has(type)) return type;
  const ext = /\.([a-z0-9]{1,5})$/i.exec(filename)?.[1]?.toLowerCase();
  return (ext !== undefined ? BY_EXTENSION[ext] : undefined) ?? 'application/octet-stream';
}

export type SaveFileErrorCode = 'PERMISSION_DENIED' | 'NO_APP' | 'CANCELED';

/**
 * 原生那边拒绝时带的原因：`DownloadsPlugin.java` 的 code，以及分享面板被关掉
 * （Share 插件只给一句 `Share canceled`，没有 code）。认不出来的给 null，按未知错误处理。
 */
export function saveFileErrorCode(error: unknown): SaveFileErrorCode | null {
  if (typeof error !== 'object' || error === null) return null;
  const { code, message } = error as { code?: unknown; message?: unknown };
  if (code === 'PERMISSION_DENIED' || code === 'NO_APP') return code;
  if (typeof message === 'string' && /cancel/i.test(message)) return 'CANCELED';
  return null;
}
